import React from 'react';
import { useSelector } from 'react-redux'

const Hidden = () => {
  const hiddenParameters = [
    'product_quote_number',
    'supplier_selected',
    'row_selected',
    'column_selected'
  ]

  const {
    parameters
  } = useSelector((state) => state.mx_assembly)


  return <>
    {hiddenParameters.map((name) =>
      <input key={name} type="hidden" name={`parameters[${name}]`} value={parameters[name] || ''} />
    )}
  </>
}

export default Hidden;